import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';
import { ChangeNavbar } from '../../actions';
//import { Link } from "react-router-dom";

import HeaderYoutube from '../../components/HeaderYoutube';
import Separator from '../../components/Separator';

import './Hirilun.css';
import '../../components/Header.css';

import logo from '../../images/games/hirilun/hirilun_letras.png';
import steam from '../../images/games/steam/steam-seal.png';

import {
  Container,
  Row,
  Col
} from 'reactstrap';


class Hirilun extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  headerContent() {
    return (
      <Container className="header-content">
        <Row className="header-image">
          <Col lg="8" className="mx-auto">
            <img className="img-fluid" src={logo} alt=""/>
          </Col>
        </Row>
        <br/><br/><br/>
        <Row className="header-text">
          <Col md="10" className="mx-auto text-center">
            <ul className="list-inline">
              <li className="list-inline-item">
                <a href="https://store.steampowered.com/app/1407300/Hirilun/" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-steam"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a href="https://discord.gg/WhkdaNsD82" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-discord"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a href="https://twitter.com/Hirilun" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a href="https://www.facebook.com/Hirilun" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a href="https://www.instagram.com/hirilun" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    );
  }

  render() {
    return (
      <div className="content">
        <HeaderYoutube className="hirilun" video_id="psUmIHBFh4Y" header_content={this.headerContent} start_time="6" end_time="72" />
        <Separator topSeparator="false" />

        <section>
          <Container>
            <Row>
              <Col lg="12" className="mx-auto text-center">
                <h2 className="title"><Translate id="hirilun.about.title">Hirilun</Translate></h2>
                <hr className="hr-line" />
              </Col>
            </Row>
            <Row className="abstract">
              <Col lg="12" className="mx-auto text-justify">
                <br/>
                <p>
                  <Translate id="hirilun.about.text1">
                    En este juego de plataformas en primera persona contrarreloj, tendrás que explorar Hirilun, una ciudad oscura y extraña, llena de rincones ocultos y edificios enormes.
                  </Translate>
                </p>
                <p>
                  <Translate id="hirilun.about.text2">
                    Corre, salta, esprinta, planea e impúlsate para conseguir el mejor tiempo y competir contra tus amigos y a nivel mundial. Aunque cualquiera puede adentrarse en Hirilun, sólo los más rápidos alcanzarán la fama...
                  </Translate>
                </p>
                <p>
                  <ul className="hirilun-list">
                    <li className="hirilun-item">
                      <Translate id="hirilun.about.list.item1">
                        Deberás moverte con mucha rapidez, corriendo y saltando sin parar, para pasar por todos los checkpoints y alcanzar tu objetivo.
                      </Translate>
                    </li>
                    <li className="hirilun-item">
                      <Translate id="hirilun.about.list.item2">
                        Podrás sprintar, planear e impulsarte por el aire, pero utiliza estos poderes sabiamente, pues son limitados.
                      </Translate>
                    </li>
                    <li className="hirilun-item">
                      <Translate id="hirilun.about.list.item3">
                        Cada nivel puede tener multitud de rutas diferentes. ¿Cuál será el camino más rápido? Tendrás que averiguarlo...
                      </Translate>
                    </li>
                    <li className="hirilun-item">
                      <Translate id="hirilun.about.list.item4">
                        Recoger las vivencias que encontrarás por el camino hará que tu cronómetro se detenga temporalmente, pero puede que no siempre merezca la pena el desvío...
                      </Translate>
                    </li>
                    <li className="hirilun-item">
                      <Translate id="hirilun.about.list.item5">
                        Compite con tus amigos y en rankings mundiales que se actualizan cada día.
                      </Translate>
                    </li>
                  </ul>
                </p>

                <br/><br/>
                <p className="text-center">
                  <iframe src="https://store.steampowered.com/widget/1407300/" frameborder="0" width="646" height="190"></iframe>
                </p>
              </Col>
            </Row>
          </Container>
        </section>

        <section>
          <Container>
            <Row>
              <Col lg="8" className="mx-auto text-center">
                <h2 className="title"><Translate id="hirilun.next">Demo disponible en:</Translate></h2>
                <hr className="hr-line" /><br/>
                <a href="https://store.steampowered.com/app/1407300/Hirilun/"  target="_blank" rel="noopener noreferrer">
                  <img className="img-fluid hirilun-steam-seal" src={steam} alt="Steam link to demo"/>
                </a>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SetHeaderNavbar: (haveHeader) => {dispatch(ChangeNavbar(haveHeader))}
  }
}

function mapStateToProps(state) {
  return {  }
}

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(Hirilun);
